


<div class="row">
    <div class='col-md-3'></div>
    <div class='col-md-6 text-center'>
        <fa-icon [icon]="faThumbsUp" class="fa-10x" style="color: lightgray;"></fa-icon>
        <div class="m-5">
            <h1 *ngIf="result">Your email address has been verified. </h1>
            <h1 *ngIf="!result">An error occured please try again later or contact support.</h1>
        </div>
        <button  mat-raised-button routerLink="/dashboard" class="m-2">Return to race</button>
    </div>
    <div class='col-md-3'></div>
</div>